import { createTheme } from '@material-ui/core'

const theme = createTheme({
    palette: {
        primary: {
            main: '#577883'
        },
        secondary: {
            main: '#afacac'
        }
    }
})

export default theme;